export const PLAN_CONFIG = {
  free: {
    name: 'Free',
    color: '#64748b',
    gradient: 'linear-gradient(135deg,#64748b,#475569)',
    accent: '#f1f5f9',
    accentDark: '#e2e8f0',
    sidebarBg: '#f8fafc',
    isDark: false,
    badge: '🆓',
  },
  pro: {
    name: 'Pro',
    color: '#6366f1',
    gradient: 'linear-gradient(135deg,#6366f1,#8b5cf6)',
    accent: '#ede9fe',
    accentDark: '#c4b5fd',
    sidebarBg: '#f5f3ff',
    isDark: false,
    badge: '⚡',
  },
  enterprise: {
    name: 'Enterprise',
    color: '#d97706',
    gradient: 'linear-gradient(135deg,#f59e0b,#d97706)',
    accent: '#fef9c3',
    accentDark: '#fde68a',
    sidebarBg: '#fffbeb',
    isDark: false,
    badge: '👑',
  },
};
